function write_message(to_contact_id, type, content, args) {
    var $ = jQuery.noConflict();

    type = type == undefined ? 'default' : type;
    if(args == undefined) {
        args = [];
    }

    $.squdeAjaxPopup({
        url: '/messages/write/'+type,
        data: {id: to_contact_id, args:args},
        onOpen: function (elm, popup) {
            if(content != undefined && content.length > 0) {
                elm.find('#text').val(content);
            }

            initiate_default_message_selector(elm);


            if(type == "course") {

                elm.find('.student-message-form, .supervisor-message-form, .teacher-message-form').hide();
                elm.find('.mass-message-selected-students-table').bind('onReload', function() {
                    const table = $(this);
                    const show_or_hide_mail_forms = function() {
                        const form = table.parents('form');
                        const data = form.serializeJSON();

                        elm.find('.message-form').hide();
                        if(data.contacts !== undefined) {
                            const keys = Object.keys(data.contacts);
                            keys.forEach(function(key) {
                                elm.find('.'+key+'-message-form').show();
                            });
                        }

                        form.find('[type="submit"]').removeAttr('disabled');
                        if(elm.find('.message-form:visible').length === 0) {
                            form.find('[type="submit"]').attr('disabled','disabled');
                        }
                    };
                    show_or_hide_mail_forms();
                    table.find('input[type=checkbox]:not(.check-whole-table)').change(function() {
                        show_or_hide_mail_forms();
                    });

                    table.find('a').updateOnClick('view_contact', function(id) {
                        view_contact(id, function(data, elm, contact_popup) {
                            contact_popup.close();
                            updateObject('contact', id);
                        });
                    });
                }).reloadThisElement();
            }

            elm.find('form').ajaxFormSubmit(function(data){
                $('body').doneLoading();
                ajax_popup_scroll_to_next_screen(function() {
                    elm.find('.visual-icon-paper-plane').addClass('fly-in');
                });
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                if($('.squde-flash').length == 0) {
                    squde_flash("Er ging iets mis bij het opslaan.", "alert");
                }
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function write_employee_message(to_employee_id, type) {
    squde_flash("Dit is nog in ontwikkeling...", "alert");
}
function send_helpdesk_message(content) {
    return write_message(0,'helpdesk', content);
}
function add_default_message(vars) {
    var $ = jQuery.noConflict();

    if(typeof vars == 'function') {
        vars = {callback: vars};
    }

    $.squdeAjaxPopup({
        url: '/messages/default/add',
        data: vars.filters === undefined ? {} : vars.filters,
        onOpen: function (elm, popup) {
            var val = null;

            elm.find('form').ajaxFormSubmit(function(data){
                popup.close();
                if(vars != undefined && vars.reload_item != undefined) {
                    $('body').doneLoading();
                    //console.log(vars.reload_item);
                    //console.log($(vars.reload_item));
                    $(vars.reload_item).reloadThisElement();
                } else if(vars!= undefined && vars.callback != undefined) {
                    $('body').doneLoading();
                    vars.callback(data, elm, popup);
                }
                else {
                    reload_location_if_needed();
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                console.log(xhr,status,error);
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function view_default_message(id, vars) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/messages/default/view/'+id,
        onOpen: function(elm, popup) {
            elm.bind('onDelete-default_message-' + id, function() {
                popup.close();
            });


            elm.find('form').ajaxFormSubmit(function(data){
                if(vars == undefined || vars.callback == undefined) {
                    $('body').append('<div class="i-am-loading"></div>');
                    reload_location_if_needed();
                } else {
                    $('body').doneLoading();
                    vars.callback(data, elm, popup);
                }
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function delete_default_message(id,name) {
    var $ = jQuery.noConflict();

    name = decodeURI(name);
    custom_delete_with_confirmation("/messages/default/delete",id,"Weet u zeker dat u \""+name+"\" wilt verwijderen?",'default_message', function() {
        reload_location_if_needed()
    });

    return false;
}

function initiate_default_message_selector(elm) {
    const $ = jQuery.noConflict();
    elm.find('[data-default-message-selector]').defaultMessageSelector().change(function() {
        const sel = $(this);
        let related = sel.attr('data-related');
        if(related === undefined) {
            return;
        }
        related = related.split(',');
        const subject_field = related[0];
        const text_field = related[1];

        $(this).getObject(function(obj) {
            elm.find('#'+subject_field).val(obj.subject);
            try {
                tinymce.get(text_field).setContent(obj.content);
            } catch(e) {
                elm.find('textarea#' + text_field).html(obj.content);
            }
        });
    });
}

/**
 * View a single sent message
 *
 * @param message_id
 * @returns {boolean}
 */
function view_message(message_id) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/messages/view/' + message_id,
        onOpen: function(elm, popup) {

        }
    });
    return false;
}

/**
 * View a single sent message
 *
 * @param message_id
 * @returns {boolean}
 */
function delete_message(message_id) {
    custom_delete_with_confirmation('/messages/delete/' + message_id, message_id, 'Weet u zeker dat u dit bericht wilt verwijderen?','message', () => {
        reload_location_if_needed();
    });

    return false;
}

function resend_message(message_id, original_email) {
    const $ = jQuery.noConflict();

    foundationPopup($('<div class="squde-popup-html">' +
            '<h3>Bericht opnieuw verzenden</h3>' +
            '<hr />' +
            '<form action="#">' +
                '<label for="to">Aan:<br />' +
                    '<input type="email" value="' + original_email + '" id="to" name="to"/>' +
                '</label>' +
                '<label for="cc">CC:<br />' +
                    '<input type="email" id="cc" name="cc" />' +
                '</label>' +
                '<label for="bcc">BCC:<br />' +
                    '<input type="email" id="bcc" name="bcc" />' +
                '</label>' +
                '<br />' +
                '<a href="#" class="button secondary">Annuleren</a> <button class="button primary" type="submit">Verzenden</button>' +
            '</form>' +
        '</div>'), function(elm, popup) {
        elm.find('a').click(function() {
            popup.close();
            return false;
        });

        elm.find('form').submit(function() {
            const data = $(this).serializeJSON();

            $.post('/messages/resend/' + message_id, data, function(data) {
                squde_reload_for_flashes();
                reload_location_if_needed(true);
            });
            return false;
        });
    }, 'tiny');

    return false;
}

function resend_all_messages() {
    const $ = jQuery.noConflict();

    foundationPopup($('<div class="squde-popup-html">' +
        '<h3>Berichten opnieuw verzenden</h3>' +
        '<hr />' +
        '<form action="#">' +
        '<label for="to">Aan:<br />' +
        '<input type="email" value="Origineel ingesteld adres" id="to" disabled style="font-style: italic;"/>' +
        '</label>' +
        '<label for="cc">CC:<br />' +
        '<input type="email" id="cc" name="cc" />' +
        '</label>' +
        '<label for="bcc">BCC:<br />' +
        '<input type="email" id="bcc" name="bcc" />' +
        '</label>' +
        '<br />' +
        '<a href="#" class="button secondary">Annuleren</a> <button class="button primary" type="submit">Verzenden</button>' +
        '</form>' +
        '</div>'), function(elm, popup) {
        elm.find('a').click(function() {
            popup.close();
            return false;
        });
        const selection = $('input[name="messages[]"]:checked');
        const message_ids = [];
        selection.each(function() {
            message_ids.push($(this).val());
        });

        elm.find('form').submit(function() {
            const data = $(this).serializeJSON();
            data.messages = message_ids;

            $.post('/messages/resend', data, function() {
                squde_reload_for_flashes();
                reload_location_if_needed(true);
            });
            return false;
        });
    }, 'tiny');


    return false;
}
